import { LatLngBoundsExpression } from "leaflet";
import React from "react";
import {
    LayersControl,
    MapContainer,
    TileLayer
} from "react-leaflet";
import { useAppSelector } from "../../app/hooks";
import CustomMapMarkers from "../../features/map/CustomMapMarkers";
import { messstelle } from "../../utils/apiTypes";
import { transformMessstelleToMapMarkers } from '../../utils/utils';
import { selectMesspunkte } from "./netzwirtschaftSlice";


export interface NetzwirtschaftMapProps {
    mapBounds: LatLngBoundsExpression;
    messpunkt: string;
}
export const NetzwirtschaftMap = ({ mapBounds, messpunkt }: NetzwirtschaftMapProps): JSX.Element => {

    const messpunkteSelectList: messstelle[] = useAppSelector(selectMesspunkte);

    return (
        <MapContainer
            center={[48.77567070986346, 9.180986090101056]}
            zoom={5}
            scrollWheelZoom={true}
            bounds={mapBounds}
            style={{ height: "500px", width: "1000px" }}
        >
            <LayersControl position="topright">
                <LayersControl.BaseLayer checked name="Karte">
                    <TileLayer
                        attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                </LayersControl.BaseLayer>
                <LayersControl.BaseLayer name="Satellit">
                    <TileLayer
                        attribution='© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> <strong>'
                        url="https://api.tiles.mapbox.com/v4/mapbox.satellite/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoidG1vZGVuYmFjaCIsImEiOiJja3VyNGhvZXEwdHYxMzBzN3M2bjd5enhkIn0.WcAlquTnMudDgG7lFqdQIQ"
                    />
                </LayersControl.BaseLayer>
            </LayersControl>
            <CustomMapMarkers
                markers={transformMessstelleToMapMarkers(messpunkteSelectList)}
                bounds={mapBounds}
                selectedMarker={messpunkt}
            />
        </MapContainer>
    );
}
